/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Set_DefaultInputs */

const cs_pipelines_set_default = /** @type {(inputs: Pipelines_Set_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit jako výchozí`)
};

const en_pipelines_set_default = /** @type {(inputs: Pipelines_Set_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set as default`)
};

/**
* | output |
* | --- |
* | "Set as default" |
*
* @param {Pipelines_Set_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_set_default = /** @type {((inputs?: Pipelines_Set_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Set_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_set_default(inputs)
	return cs_pipelines_set_default(inputs)
});